import { api } from '../api'

export const organizationApi = api
  .enhanceEndpoints({
    addTagTypes: ['organizationCards', 'nonProdCards'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getOrganizations: builder.query({
        query: () => {
          return {
            url: `/organizations`,
            method: 'GET',
          }
        },
        transformResponse: (response) =>
          response?.data.map(({ id, name }) => ({
            id,
            value: name,
            label: name,
          })) || [],
      }),
    }),
  })

export const { useGetOrganizationsQuery } = organizationApi
